import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-300" data-mp="2urlqfht25jf">
      <div className="max-w-5xl mx-auto" data-id="element-301" data-mp="2tzoz1ch21rk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-302" data-mp="2x5daeda0zm8">
          <div data-id="element-303" data-mp="3u2x1373l005v">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-5 text-blue-950 uppercase" data-id="element-304" data-mp="3g9xpvhau0s44">
              See the Flight Concept Before You Teach It
            </h2>
            <p className="text-xl font-semibold text-blue-950 mb-1" data-id="element-305" data-mp="3l6ec25yh0wek">Flying is practical.</p>
            <p className="text-xl font-semibold text-orange-500 mb-5" data-id="element-306" data-mp="36dkw6jfaee9d">
              Your teaching material should be practical too.
            </p>
            <p className="text-slate-800 leading-relaxed mb-3" data-id="element-307" data-mp="eqsn9rhhxlrv">
              <span className="font-semibold text-blue-950" data-id="element-308" data-mp="9shezl6unjbr">
                Flight Instructor Ready is 100% visual.
              </span>
            </p>
            <p className="text-slate-800 leading-relaxed" data-id="element-309" data-mp="nqyzzb5dehpz">
              Throughout the complete 6-in-1 system, complex flight concepts are supported with
              visual resources designed to make them easier for the instructor to explain and easier
              for the student to understand.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6" data-id="element-310" data-mp="3n5aszmjysp8b">
            <p className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-4" data-id="element-311" data-mp="4uz5ntox7238">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-312" data-mp="38i96n61078cu">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-313" data-mp="34hfkah37m1m2">
                  <CheckCircle2 size={16} className="text-blue-600 shrink-0 mt-0.5" data-id="element-314" data-mp="17gjcnkb65wb7" />
                  <span data-id="element-315" data-mp="1cfcufoxho9h6">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-serif font-extrabold text-blue-950 mt-14" data-id="element-316" data-mp="1h5jj1os03tzf">
          <span className="text-orange-500" data-id="element-317" data-mp="1m5flvkoypfde">100% VISUAL.</span> PRACTICAL. READY TO TEACH.
        </p>
      </div>
    </section>;
}